export const FIELD_NAME = "imageGenerationType";
export const FIELD_LABEL = "Choose an Image type:";

export const IMAGE_TYPE_LIFESTYLE = "lifestyle";
export const IMAGE_TYPE_PRODUCT = "product";
const IMAGE_TYPE_CLAIM = "claim";

export const LABEL_LIFESTYLE = "Lifestyle";
export const LABEL_PRODUCT = "Product";
export const LABEL_CERTIFICATIONS = "Certifications";

const TOOLTIP_TYPE_LIFESTYLE = "Lifestyle images";
const TOOLTIP_TYPE_PRODUCT = "Product images";

const TOOLTIP_DESC_LIFESTYLE = "Products in real-life settings.";
const TOOLTIP_DESC_PRODUCT = "Single/multiple wrapped products or shelf-ready packaging.";
const TOOLTIP_DESC_CERTIFICATIONS = "Badges or logos of an external authority used as a reinforcement of brand or product purpose.";

export const imageTypeOptions = [
  {
    id: IMAGE_TYPE_LIFESTYLE,
    label: LABEL_LIFESTYLE,
    ariaLabel: LABEL_LIFESTYLE,
  },
  {
    id: IMAGE_TYPE_PRODUCT,
    label: LABEL_PRODUCT,
    ariaLabel: LABEL_PRODUCT,
  },
  {
    id: IMAGE_TYPE_CLAIM,
    label: LABEL_CERTIFICATIONS,
    ariaLabel: LABEL_CERTIFICATIONS,
  },
];

export const inputTypeToolTipContent = [
  {
    type: TOOLTIP_TYPE_LIFESTYLE,
    description: TOOLTIP_DESC_LIFESTYLE,
  },
  {
    type: TOOLTIP_TYPE_PRODUCT,
    description: TOOLTIP_DESC_PRODUCT,
  },
  {
    type: LABEL_CERTIFICATIONS,
    description: TOOLTIP_DESC_CERTIFICATIONS,
  },
];
